// import successAutoImg from "../../../assets/fahrgestellnummer-pruefen/banner-auto-success.avif";
import successAutoImg2 from "../../../assets/fahrgestellnummer-pruefen/banner-auto-success2.avif";
import finUeberPruefungImg from "../../../assets/fahrgestellnummer-pruefen/Auto-verkaufen-app.jpg";
// import kostenloseUeberpruefung from "../../../assets/fahrgestellnummer-pruefen/kostenlose-fin-ueberpruefung.avif";
import kostenloseUeberpruefung2 from "../../../assets/fahrgestellnummer-pruefen/kostenlose-fin-ueberpruefung2.avif";

import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

export const BannerSections = () => {
  return (
    <div className="Banner-sections">
      <BildTextInfo
        image={successAutoImg2}
        title={<>Was ist die Fahrgestellnummer</>}
        alt="Ein erfolgszeichen mit einem weißem auto im Hintergrund"
        revert
        h2
        text={
          <>
            <p>
              Alle registrierten Fahrzeuge in Österreich haben eine
              einzigartige, eingestanzte Fahrgestellnummer. Die FIN enthält
              Informationen über die Ausstattung, Spezifikationen und den
              Hersteller deines Autos. Sie kann verwendet werden, um Rückrufe,
              Zulassungen, Garantieansprüche, Diebstahl und Versicherungsschutz
              nachzuverfolgen.
            </p>
          </>
        }
      />

      <BildTextInfo
        image={finUeberPruefungImg}
        title="Wo kann man die FIN-Nummer überprüfen?"
        alt="FIN abfrage auf dem Iphone"
        h2
        text={
          <>
            <ul>
              <li>
                <strong>Kostenpflichtig: </strong>Anbieter wie autoDNA oder
                VIN-Info bieten gegen eine Gebühr von 15–20 Euro detaillierte
                Berichte zur FIN-Nummer, inklusive Unfallhistorie und
                Serviceeinträgen.
              </li>
              <li>
                <strong>Kostenlos: </strong>Auf Autoeinfachlos kannst du
                kostenlos einen Bericht erstellen, der grundlegende
                Informationen wie Marktwert und Ausstattung deines Fahrzeugs
                liefert – perfekt für einen schnellen Überblick.
              </li>
            </ul>
          </>
        }
      />

      <BildTextInfo
        image={kostenloseUeberpruefung2}
        title={<>Was beinhaltet eine kostenlose FIN Abfrage?</>}
        revert
        alt="FIN abfrage erfolgreich dem Iphone"
        h2
        text={
          <>
            <ul>
              <li className="removePadding">
                <strong>Ein Basisbericht mit 20 Einträgen: </strong>
                Erhalte detaillierte Informationen zu deinem Fahrzeug,
                einschließlich des ursprünglichen Listenpreises.
              </li>
              <li className="removePadding">
                <strong>Ausstattung deines Fahrzeugs: </strong>
                Alle Serien- und Sonderausstattungen werden übersichtlich
                aufgelistet.
              </li>
              <li className="removePadding">
                <strong>Aktueller Marktwert: </strong>
                Zusätzlich erhältst du kostenlos eine Bewertung des aktuellen
                Marktwerts deines Fahrzeugs basierend auf den neuesten Daten.
              </li>
            </ul>
          </>
        }
      />
    </div>
  );
};
